import { createContext, useContext, useState, ReactNode } from "react";

interface SidebarContextType {
  expanded: boolean;
  setExpanded: (expanded: boolean) => void;
}

const SidebarContext = createContext<SidebarContextType | undefined>(undefined);

// Use a module-level ref to persist expanded state across route changes
let persistentExpanded = false;

export const SidebarProvider = ({ children }: { children: ReactNode }) => {
  const [expanded, setExpandedState] = useState(persistentExpanded);

  const setExpanded = (value: boolean) => {
    persistentExpanded = value;
    setExpandedState(value);
  };

  return (
    <SidebarContext.Provider value={{ expanded, setExpanded }}>{children}</SidebarContext.Provider>
  );
};

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (context === undefined) {
    throw new Error("useSidebar must be used within a SidebarProvider");
  }
  return context;
};
